import Moment from 'moment';
import Resource from './Resource';

/**
 * Activity Resource
 */
class Activity extends Resource
{
    constructor() {
        super('activity', ['activities']);
    }

    complete(id) {
        return this._doPost([id, 'complete'])
    }

    uncomplete(id) {
        return this._doPost([id, 'uncomplete'])
    }

    destroySeries(id, params = {}) {
        return this._doDelete(['series', encodeURIComponent(id)], params);
    }

    options(params) {
        return this._doGet(['options'], params);
    }
}   

export let ActivityResource = new Activity();

export let ActivitySchema = function(defaults = {}) {
    let schema = {
        contact_id: null,
        lead_id: null,
        instance_id: null,
        title: null,
        medium: null,
        notes: null,
        due_at: null,
        owner_id: null,
        completed_at: null,
        created_by_id: null,
        instance_id: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

export let ActivityMediums = {
    CALL: 'call', 
    SMS: 'sms',
    EMAIL: 'email', 
    APPOINTMENT: 'appointment', 
    TASK: 'task',
    TEST_DRIVE: 'test_drive',
    HAND_OVER: 'hand_over',
};

export let ActivityMediumsKeyValueList = [
    { value: ActivityMediums.CALL, label: 'Call', icon: 'phone' },
    { value: ActivityMediums.SMS, label: 'SMS', icon: 'sms' },
    { value: ActivityMediums.EMAIL, label: 'Email', icon: 'send' },
    { value: ActivityMediums.TASK, label: 'Task', icon: 'flag' },
    { value: ActivityMediums.APPOINTMENT, label: 'Appointment', icon: 'today' },
    { value: ActivityMediums.TEST_DRIVE, label: 'Test Drive', icon: 'directions_car' },
    { value: ActivityMediums.HAND_OVER, label: 'Hand Over', icon: 'key' },
]

export let ActivityMediumsListItemRetriever = (value) => {
    return ActivityMediumsKeyValueList.find(item => {
        return item.value === value
    })
}